import { render, staticRenderFns } from "./BoxOpenClose.vue?vue&type=template&id=567e6b04"
import script from "./BoxOpenClose.vue?vue&type=script&lang=js"
export * from "./BoxOpenClose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports